import { memo } from "react";
import { ColorPicker, Slider, InputNumber, Divider } from "antd";
import styled from "styled-components";
import { LayerStyles, colorToHex } from "../types";

interface PointStyleTabProps {
  styles: LayerStyles;
  onUpdate: (field: keyof LayerStyles['point'], value: any) => void;
}

const PointStyleTab = ({ styles, onUpdate }: PointStyleTabProps) => {
  return (
    <StyleForm>
      <FormRow>
        <FormLabel>Màu điểm:</FormLabel>
        <ColorPicker
          value={styles.point.color}
          onChange={(color) => onUpdate('color', colorToHex(color))}
          showText
        />
      </FormRow>

      <FormRow>
        <FormLabel>Bán kính:</FormLabel>
        <Slider
          min={2}
          max={20}
          value={styles.point.radius}
          onChange={(value) => onUpdate('radius', value)}
          style={{ flex: 1 }}
        />
        <InputNumber
          min={2}
          max={20}
          value={styles.point.radius}
          onChange={(value) => onUpdate('radius', value || 8)}
          style={{ width: 60 }}
        />
      </FormRow>

      <FormRow>
        <FormLabel>Độ mờ:</FormLabel>
        <Slider
          min={0}
          max={1}
          step={0.1}
          value={styles.point.opacity}
          onChange={(value) => onUpdate('opacity', value)}
          style={{ flex: 1 }}
        />
        <span style={{ width: 60, textAlign: 'center' }}>
          {Math.round(styles.point.opacity * 100)}%
        </span>
      </FormRow>

      <Divider />

      <FormRow>
        <FormLabel>Màu viền:</FormLabel>
        <ColorPicker
          value={styles.point.strokeColor}
          onChange={(color) => onUpdate('strokeColor', colorToHex(color))}
          showText
        />
      </FormRow>

      <FormRow>
        <FormLabel>Độ dày viền:</FormLabel>
        <Slider
          min={0}
          max={5}
          value={styles.point.strokeWidth}
          onChange={(value) => onUpdate('strokeWidth', value)}
          style={{ flex: 1 }}
        />
        <InputNumber
          min={0}
          max={5}
          value={styles.point.strokeWidth}
          onChange={(value) => onUpdate('strokeWidth', value || 2)}
          style={{ width: 60 }}
        />
      </FormRow>
    </StyleForm>
  );
};

export default memo(PointStyleTab);

const StyleForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 0;
`;

const FormRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const FormLabel = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  min-width: 120px;
`;
